import { Trip } from '@/typing/api/tripNew.class';
import MaterialIcon from '@/typing/enums/materialIcon.enum';
import { TripStatus } from '@/typing/enums/tripStatus.enum';

export const statusIconColorFn = (item: Trip) => {
    if (
        item.status === TripStatus.RejectedClient ||
        item.status === TripStatus.RejectedContractor
    ) {
        return '#ff0000';
    } else if (item.status === TripStatus.OpenClient) {
        return '#1e466f';
    } else if (item.status === TripStatus.ApprovedClient) {
        return '#78ff00';
    }

    return 'transparent';
};

export const statusIconNameFn = (item: Trip) => {
    if (
        item.status === TripStatus.OpenContractor ||
        item.status === TripStatus.OpenSkipper
    ) {
        return '';
    } else if (
        item.status === TripStatus.RejectedClient ||
        item.status === TripStatus.RejectedContractor
    ) {
        return MaterialIcon.Close;
    } else if (item.status === TripStatus.OpenClient) {
        return MaterialIcon.Send;
    } else if (item.status === TripStatus.ApprovedClient) {
        return MaterialIcon.Done;
    }

    return '';
};

export const iconTitleFn = (item: Trip) => {
    if (item.status === TripStatus.RejectedClient) {
        return 'Afgekeurd door opdrachtgever';
    } else if (item.status === TripStatus.RejectedContractor) {
        return 'Afgekeurd door aannemer';
    } else if (item.status === TripStatus.ApprovedClient) {
        return 'Goedgekeurd door opdrachtgever';
    } else if (item.status === TripStatus.OpenClient) {
        return 'Te controleren door opdrachtgever';
    }

    return null;
};
